import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit"
import { get } from "../../lib/request"

export const fetchPostEditHistory = createAsyncThunk(
  "postEditHistory/fetchByPostId",
  async (postId, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const token = state.auth?.token

      if (!token) {
        throw new Error("Authentication required. Please login first.")
      }

      if (!postId) {
        throw new Error("Post ID is required")
      }
      const endpoint = `/content-post-edit-history/posts/${postId}`
      const data = await get(endpoint)

      return { postId, history: data }
    } catch (error) {
      console.error(` Failed to fetch post edit history for postId ${postId}:`, error.message)
      return rejectWithValue(error.message || "Failed to fetch post edit history")
    }
  },
)

const initialState = {
  historyByPostId: {},
  status: "idle",
  error: null,
  activePostId: null,
}

const postEditHistorySlice = createSlice({
  name: "postEditHistory",
  initialState,
  reducers: {
    clearPostEditHistoryError: (state) => {
      state.error = null
    },
    setActivePostId: (state, action) => {
      state.activePostId = action.payload
    },
    clearPostEditHistory: (state) => {
      state.historyByPostId = {}
      state.status = "idle"
      state.error = null
      state.activePostId = null
    },
    resetPostEditHistoryOnLogout: (state) => {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPostEditHistory.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(fetchPostEditHistory.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.error = null
        const { postId, history } = action.payload
        state.historyByPostId[postId] = history
      })
      .addCase(fetchPostEditHistory.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

const selectHistoryByPostId = (state) => state.postEditHistory.historyByPostId

export const selectPostEditHistoryByPostId = createSelector(
  [selectHistoryByPostId, (state, postId) => postId],
  (historyByPostId, postId) => historyByPostId[postId] || [],
)

export const selectPostEditHistoryStatus = (state) => state.postEditHistory.status
export const selectPostEditHistoryError = (state) => state.postEditHistory.error
export const selectActivePostId = (state) => state.postEditHistory.activePostId

export default postEditHistorySlice.reducer
